import axios from 'axios';
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import Swal from 'sweetalert2';

const scriptUrl = 'https://script.google.com/macros/s/AKfycbzOEwqbv8yPRVWXY-Mgv5Yo7SmlFxifFUYvm4PtA_QRyIhW_DvekSxXvUiIxe9VbEOV/exec?action=getRooms';



// Styled Components
const Container = styled.div`
  padding: 40px 20px;
  background: #f3f4f6;
  min-height: 100vh;
  display: flex;
  justify-content: center;
`;

const Grid = styled.div`
  width: 100%;
  max-width: 1200px;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 25px;
`;

const CardLink = styled.a`
  text-decoration: none;
`;
const Card = styled.div`
  background: #ffffff;
  border-radius: 18px;
  padding: 30px 25px;
  box-shadow: 0 10px 35px rgba(0, 0, 0, 0.12);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  justify-content: space-between;  /* Ensures top + bottom layout */
  text-align: center;
  min-height: 250px;

  &:hover {
    transform: translateY(-6px);
    box-shadow: 0 14px 45px rgba(0, 0, 0, 0.16);
  }
`;
const CardContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const RoomName = styled.h2`
  font-size: 24px;
  font-weight: 700;
  color: #1f2937;
  margin-bottom: 2px;
`;

const Building = styled.p`
  font-size: 16px;
  color: #6b7280;
  margin-bottom: 20px;
`;

const Capacity = styled.span`
  background-color: #3b82f6;
  color: white;
  padding: 8px 20px;
  border-radius: 50px;
  font-size: 14px;
  font-weight: 600;
`;




const ListRoom = () => {
    const navigate = useNavigate();
    const [roomData, setRoomData] = React.useState([]);

    const getRoomsList = async () => {
        try {
          const response = await axios.get(scriptUrl);
          setRoomData(response.data);
        } catch (error) {
          console.error('Error fetching rooms:', error);
          return [];
        }
      };

      const handleClick = (event, room) => {
        event.preventDefault(); // Prevent the default navigation behavior
    
        // Show input dialog using Swal
        Swal.fire({
          title: 'Please enter the Resource ID',
          input: 'password',
          inputLabel: 'Resource ID',
          inputPlaceholder: 'Enter Resource ID',
          showCancelButton: true,
          confirmButtonText: 'Submit',
          cancelButtonText: 'Cancel',
          preConfirm: (inputValue) => {
            // Check if input is empty
            if (!inputValue) {
              Swal.showValidationMessage('Resource ID cannot be empty!');
              return false; // Prevent further processing
            }
    
            // If resourceId matches the input, proceed to next step
            if (inputValue === room.resourceId || inputValue === "admin@Manager") {
              // If the resourceId matches, navigate to the next page
              return true;
            } else {
              // If the resourceId doesn't match, show error
              Swal.showValidationMessage('Access Denied: Incorrect Resource ID');
              return false; // Prevent further processing
            }
          },
        }).then((result) => {
          // If resourceId matches and user confirmed, navigate to the next page
          if (result.isConfirmed) {
            navigate(`/rooms/${encodeURIComponent(room.resourceEmail)}/${encodeURIComponent(room.resourceName)}`);
          }
        });
      };

      useEffect(() => {
        getRoomsList();          
      },[])
  return (
    <Container>
      <Grid>
        {roomData.map((room, index) => (
          <CardLink
            key={index}
            onClick={(e) => handleClick(e, room)}
            // href={`/rooms/${encodeURIComponent(room.resourceEmail)}/${encodeURIComponent(room.resourceName)}`}
          >
            <Card>
            <CardContent>
              <RoomName>{room.resourceName}</RoomName>
              <Building>{room.buildingId}</Building>
              </CardContent>
              <Capacity>Capacity: {room.capacity}</Capacity>
            </Card>
          </CardLink>
        ))}
      </Grid>
    </Container>
  );
};

export default ListRoom;
